import { createVanIconComponent } from "./van"

const WarningOutlined = createVanIconComponent("warning-o")
export default WarningOutlined
